import React from 'react';
import PropTypes from 'prop-types';
import SearchBarComponent from '../../../components/SearchBar';
import {
  APPLICATION,
  API,
  ORGANIZATION,
} from '../labels';

export default function SearchBar(props) {
  let dispatchAutoSuggest;
  if (props.selectedDropdownValue === API) {
    dispatchAutoSuggest = props.fetchAvailableApis;
  }
  if (props.selectedDropdownValue === APPLICATION) {
    dispatchAutoSuggest = props.fetchAvailableApps;
  }
  if (props.selectedDropdownValue === ORGANIZATION) {
    dispatchAutoSuggest = props.fetchAvailableOrgs;
  }
  return (
    <SearchBarComponent
      dispatchAutoSuggest={dispatchAutoSuggest}
      autoSuggestSuggestions={props.autoSuggestSuggestions}
      selectedDropdownValue={props.selectedDropdownValue}
      selectedOption={props.selectedOption}
      handleSearch={props.handleSearch}
    />
  );
}

SearchBar.propTypes = {
  handleSearch: PropTypes.func,
  autoSuggestSuggestions: PropTypes.arrayOf(PropTypes.shape({
    key: PropTypes.string,
    value: PropTypes.string,
  })),
  selectedDropdownValue: PropTypes.string,
  selectedOption: PropTypes.shape(),
  fetchAvailableApis: PropTypes.func,
  fetchAvailableApps: PropTypes.func,
  fetchAvailableOrgs: PropTypes.func,
};



// WEBPACK FOOTER //
// ./src/pages/Dashboard/SearchBar/index.js